import { FC, useContext, useMemo } from 'react'
import { useQuery } from 'react-query'
import {
  createResponseContext,
  initialQueryResponse,
  QUERIES,
  stringifyRequestQuery,
  WithChildren,
} from '../../../../../../_metronic/helpers'
import { getEmpresas } from './_requests'
import { useQueryRequest } from './QueryRequestProvider'
import { EmpresaList } from './_models'
import { useModal } from '../../../../../components'

const QueryResponseContext = createResponseContext<EmpresaList>(initialQueryResponse)
export const QueryResponseProvider: FC<WithChildren> = ({ children }) => {
  const { isOpen } = useModal()
  const { state } = useQueryRequest()

  const query = useMemo(() => stringifyRequestQuery(state), [state])

  const {
    isFetching,
    isError,
    refetch,
    data: response,
  } = useQuery([QUERIES.EMPRESAS_LIST, query, isOpen], () => getEmpresas(query), {
    cacheTime: 0,
    keepPreviousData: true,
    refetchOnWindowFocus: false,
    enabled: !isOpen,
  })

  return (
    <QueryResponseContext.Provider
      value={{ isLoading: isFetching, isError, refetch, response, query }}
    >
      {children}
    </QueryResponseContext.Provider>
  )
}

export const useQueryResponse = () => useContext(QueryResponseContext)
